<template>
  <div style="position: relative;height: 100%;" v-click-outside="closeDrawer">
    <transition name="slide">
      <div class="sidebar-main" v-show="showDrawer">
        <div class="menu">
          <ul>
            <li>
              <a href="/adgroupReport">Adgroup Data</a>
              <!--<router-link :to="{name: 'AdgroupReport', query: {dateStart: '2018-07-18'}}">Adgroup</router-link>-->
            </li>
            <li>
              <a href="/revenuePartnersReport">Revenue Partner Data</a>
            </li>
            <li>
              <a href="#click" v-on:click="showRawDataPartnersReportSubMenu = !showRawDataPartnersReportSubMenu">Raw Partner Data</a>
            </li>
            <li class="rawDataPartnersReportSubMenu" v-bind:class="{ active: showRawDataPartnersReportSubMenu }">
              <a v-bind:href="getRawDataPartnersReportDailyUrl()">Daily</a>
            </li>
            <li class="rawDataPartnersReportSubMenu" v-bind:class="{ active: showRawDataPartnersReportSubMenu }">
              <a v-bind:href="getRawDataPartnersReportHourlyUrl()">Hourly</a>
            </li>
            <li>
              <a href="/hourlyPartnersReport">Hourly Partner Data</a>
            </li>
            <li>
              <a href="/scrubRateHourlyReport">Hourly ScrubRate Data</a>
            </li>
            <li>
              <a href="/targetReport">Targets Data</a>
            </li>
          </ul>
        </div>
      </div>
    </transition>
    <div class="sidebar-buton-wrapper">
      <span @click="toggleDrawer">
        <i class="sidebar-toggle-icon"></i>
      </span>
    </div>
  </div>
</template>

<script>

  import moment from 'moment';

  export default {
    name: "cc-drawer",
    data() {
      return {
        showDrawer: false,
        showExternalBuyersSubLinks: false,
        showRawDataPartnersReportSubMenu: false,
      }
    },
    methods: {
      toggleDrawer: function(){
        this.showDrawer = !this.showDrawer;
        this.$store.dispatch('setLeftSideBarStatus', this.showDrawer);
      },
      closeDrawer: function(){
        this.showDrawer = false;
        this.$store.dispatch('setLeftSideBarStatus', this.showDrawer);
      },
      getRawDataPartnersReportDailyUrl: function() {
        let filters = {
          tableTypeName: ["Ad Groups","Campaigns","Keywords","Placements","Tags","Types"],
          dateRange: {
            startDate: moment().add(-3, 'days'),
            endDate: moment().add(-1, 'days'),
          }
        };

        return '/rawDataPartnersReport?filters=' + JSON.stringify(filters);
      },
      getRawDataPartnersReportHourlyUrl: function() {
        let filters = {
          tableTypeName: ["Ad Groups Hourly","Types Hourly"],
          dateRange: {
            startDate: moment().add(-3, 'days'),
            endDate: moment().add(-1, 'days'),
          }
        };

        return '/rawDataPartnersReport?filters=' + JSON.stringify(filters);
      },

    }
  }
</script>

<style lang="scss">
  .sidebar-main {
    position: absolute;
    z-index: 9999;
    left: 0;
    min-width: 144px;
    height: 100%;
    background-color: #e2e2e2;
    -webkit-box-shadow: 3px 3px 9px 1px rgba(203,204,205,1);
    -moz-box-shadow: 3px 3px 9px 1px rgba(203,204,205,1);
    box-shadow: 3px 3px 9px 1px rgba(203,204,205,1);

    .menu > ul {
      list-style: none;
      padding-left: 10px;
      padding-bottom: 15px;
      margin-right: 15px;
      margin-left: 15px;
      text-align: left;

      li {
        padding-top: 15px;
        padding-bottom: 15px;

        a {
          color: #666666;
          font-size: 14px;
          text-decoration: none;

          &:hover {
            color: #115dff;
          }
        }

        & > ul {
          padding-left: 10px;
          list-style: none;
          text-align: left;

          & > li {
            padding-top: 10px;
            padding-bottom: 10px;
          }
        }
      }

      li.rawDataPartnersReportSubMenu {
        display: none;
        padding-left: 15px;
        padding-top: 10px;
        padding-bottom: 10px;
        a {
          font-size: 95%;
        }
      }
      li.rawDataPartnersReportSubMenu.active {
        display: block;
      }

    }

    .menu .toggle {
      background-image: url('/static/img/icon-toggle-top.svg');
      background-size: cover;
      width: 1em;
      height: 0.4em;
      display: inline-block;
      transform: rotate(180deg);
      cursor: pointer;

      &.active {
        transform: none;
      }
    }
  }

  .sidebar-toggle-icon {
    background-image: url('/static/img/sidebar-toggle-icon.svg');
    background-size: cover;
    width: 1.75em;
    height: 1.75em;
    display: inline-block;
    margin: 15px auto 0 auto;
    cursor: pointer;
  }

  .enter { transform: translateX(100%) }
  .enter-to { transform: translateX(0) }
  .slide-enter-active { position: absolute }

  .leave { transform: translateX(0) }
  .leave-to { transform: translateX(-100%) }

  .slide-enter-active,
  .slide-leave-active { transition: all 50ms ease-in-out }

</style>



// WEBPACK FOOTER //
// src/components/common/CCDrawer.vue